// src/components/TopHeader.js
import React from 'react';
import './TopHeader.css';

// DHYAN DEIN: Agar aapke logo ka format .jpg ya .svg hai, toh yahan extension change kar lena
import desktopLogo from '../assets/logo-desktop.png'; 
import mobileLogo from '../assets/logo-mobile.png';

const TopHeader = ({ toggleSidebar, handleLogout }) => {
  return (
    <header className="top-header">
      
      {/* Left Side: Hamburger + Logos */}
      <div className="header-left">
        <button className="hamburger-btn" onClick={toggleSidebar}>
          ☰
        </button>
        
        <div className="logo-container">
          {/* Desktop pe yeh dikhega */}
          <img src={desktopLogo} alt="PickupDrop Desktop" className="logo-desktop" />
          
          {/* Mobile pe yeh dikhega */}
          <img src={mobileLogo} alt="PickupDrop Mobile" className="logo-mobile" />
        </div>
      </div>

      {/* Right Side: Profile + Logout */}
      <div className="header-right">
        <div className="admin-profile">
          <div className="profile-text">
            <span className="profile-name">Super Admin</span>
            <span className="profile-role">Management</span>
          </div>
          <div className="profile-avatar">S</div>
        </div>
        
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

    </header>
  );
};

export default TopHeader;